import { render, staticRenderFns } from "./InfoPreviewCard.vue?vue&type=template&id=4d0ca4d6"
import script from "./InfoPreviewCard.vue?vue&type=script&lang=js"
export * from "./InfoPreviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports